import { Component, OnInit, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, filter, take, switchMap, catchError, withLatestFrom, map } from 'rxjs/operators';
import { InstaPost } from '../../models';
import * as fromStore from '../../store';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'app-instagram-feed',
  templateUrl: './instagram-feed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SlicePipe],
})
export class InstagramFeedComponent {
  private store = inject(Store);

  @Input() posts: InstaPost[] = [];
  storeLoaded: Observable<boolean> = of(false);

  constructor() {
    this.storeLoaded = this.checkStore();
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getInstaPostsLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadInstaPosts());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }

  trackByFn(i: number, post: InstaPost) {
    return post.instagramId;
  }
}
